import React from 'react'

//
import DeliverectOGImage from '../../public/images/Deliverect-OG-Image-white.jpg'
import { SiteDataContext } from '../components'
import { useGlobalData } from '../../pages/_app'

const getSettingsMetaTitle = (siteTitle, currentLang) => {
  if (!siteTitle) {
    return ''
  }

  const title = siteTitle.find((item) => item.locale === currentLang)
  if (!title) {
    return ''
  }

  return title.value
}

const getSettingsMetaDescription = (siteDescription, currentLang) => {
  if (!siteDescription) {
    return ''
  }

  const description = siteDescription.find((item) => item.locale === currentLang)
  if (!description) {
    return ''
  }

  return description.value
}

export const buildPageMetaTags = ({ seoData, siteMetadata }) => {
  const siteData = React.useContext(SiteDataContext)
  const currentLang = siteData.lang || 'en'
  const { settings, settingsMetaTags } = useGlobalData()
  const { market } = siteData
  const { siteImage } = settings
  const { siteDescription, siteTitle } = settingsMetaTags
  const { siteName } = siteMetadata
  const { alternate, metaTags, metaImage, pageType, marketsMetaTags } = seoData

  const marketMetaTags = getMetaTagsByEnabledMarket(market, marketsMetaTags)

  const title =
    marketMetaTags?.title ||
    metaTags?.title ||
    seoData?.title ||
    getSettingsMetaTitle(siteTitle, currentLang) ||
    ''

  const titlePrefix = market?.pageTitlePrefix || siteName

  const description =
    marketMetaTags?.description ||
    metaTags?.description ||
    `${seoData?.title || title || ''} - ${getSettingsMetaDescription(
      siteDescription,
      currentLang
    )}` ||
    ''

  const image =
    metaImage?.url ||
    siteImage ||
    `${process.env.URL || process.env.NEXT_PUBLIC_SITE_URL}${DeliverectOGImage.src}`
  const canonical = metaTags?.canonical
  const noindex = marketMetaTags?.noindex || metaTags?.noindex || false
  const nofollow = marketMetaTags?.nofollow || metaTags?.nofollow || false
  const noarchive = metaTags?.noarchive || false
  const nosnippet = metaTags?.nosnippet || false
  const maxPreviewImage = metaTags?.maxPreviewImage || false
  const keywords = metaTags?.keywords || false

  return {
    siteName,
    title: pageType === 'page404' ? `${titlePrefix} | 404 ` : `${titlePrefix} | ${title}`,
    description,
    image,
    canonical,
    noindex,
    nofollow,
    pageType,
    noarchive,
    nosnippet,
    maxPreviewImage,
    keywords,
    alternate
  }
}

function getMetaTagsByEnabledMarket(market, marketsMetaTags) {
  if (!marketsMetaTags) {
    return
  }

  const enabledMarketTitle = market.title.toLowerCase()

  return {
    title: marketsMetaTags[enabledMarketTitle]?.title,
    description: marketsMetaTags[enabledMarketTitle]?.description,
    noindex: marketsMetaTags[enabledMarketTitle]?.noindex,
    nofollow: marketsMetaTags[enabledMarketTitle]?.nofollow
  }
}
